var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 864.07 425.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f2e41;}.cls-2{fill:#fff;}.cls-3{fill:#3f3d56;}.cls-4{fill:#b4c3d6;}.cls-5{fill:#ffb8b8;}.cls-6{fill:#a0616a;}.cls-7{fill:#ccc;}.cls-8{fill:#ff6584;}.cls-9{fill:#eb8264;}.cls-10{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "konzept"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m863.17,310.5c-105.78,154.98-262.21,22.9-409.02,43.14-128.37,17.69-274.15,78.51-385.53,42.99C-2.62,373.9-10.17,308.63,9.11,201.84,51.78-34.45,232.89,56.27,336.24,75.08c172.88,31.47,315.85,145.13,483.8,199.81,19.88,6.47,49.57,19.67,43.14,35.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m836.92,252.24c0-35.37-28.69-119.3-64.09-119.3s-64.09,83.93-64.09,119.3c.03,35.39,28.75,64.06,64.14,64.03,35.35-.03,64.01-28.68,64.03-64.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m772.83,394.15c-.4,0-.73-.33-.73-.73v-149.61c0-.4.33-.73.73-.73s.73.33.73.73v149.61c0,.4-.33.73-.73.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m772.83,271.77c-.21,0-.41-.09-.55-.25l-36.86-42.51c-.26-.31-.23-.77.08-1.03.31-.26.76-.23,1.03.07l36.86,42.51c.27.31.23.77-.07,1.03-.13.12-.3.18-.48.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m772.83,296.3c-.4,0-.73-.33-.73-.73,0-.19.08-.38.21-.52l20.94-20.94c.29-.29.75-.29,1.04,0,.29.29.29.75,0,1.04l-20.94,20.94c-.14.14-.32.22-.52.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.24,314.24c0-19.92-16.16-67.18-36.09-67.18s-36.09,47.26-36.09,67.18c.01,19.93,16.18,36.08,36.12,36.06,19.91-.01,36.05-16.15,36.06-36.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m94.15,394.15c-.23,0-.41-.18-.41-.41v-84.25c0-.23.18-.41.41-.41.23,0,.41.18.41.41h0v84.25c0,.23-.18.41-.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m94.15,325.23c-.12,0-.23-.05-.31-.14l-20.76-23.94c-.15-.17-.13-.43.05-.58.17-.15.43-.13.58.04l20.76,23.94c.15.17.13.43-.04.58-.07.07-.17.1-.27.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m94.15,339.05c-.23,0-.41-.18-.41-.41,0-.11.04-.21.12-.29l11.79-11.79c.16-.16.42-.16.58,0,.16.16.16.42,0,.58l-11.79,11.79c-.08.08-.18.12-.29.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m55.06,393.61c0-8.32,6.75-15.07,15.07-15.07s15.07,6.75,15.07,15.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m70.13,393.61c-.22,0-.41-.18-.41-.41v-7.94c0-.22.18-.41.41-.41.22,0,.4.18.41.41v7.94c0,.22-.18.41-.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m70.13,390.88c-.1,0-.19-.03-.27-.1l-4.89-4.19c-.17-.15-.19-.4-.05-.57.15-.17.4-.19.57-.05h0s4.89,4.2,4.89,4.2c.17.15.19.4.04.57-.08.09-.19.14-.31.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m101.48,393.61c0-8.32,6.75-15.06,15.07-15.06,8.32,0,15.06,6.74,15.06,15.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m116.55,393.61c-.22,0-.41-.18-.41-.41v-7.94c0-.22.18-.41.41-.41.22,0,.41.18.41.41h0v7.94c0,.22-.18.41-.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m116.55,390.88c-.1,0-.19-.03-.27-.1l-4.89-4.19c-.17-.15-.19-.4-.04-.57.15-.17.4-.19.57-.04h0l4.89,4.19c.17.15.19.4.04.57-.08.09-.19.14-.31.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.87,333.74c-92.01,0-166.87-74.86-166.87-166.87S288.86,0,380.87,0s166.87,74.86,166.87,166.87-74.86,166.87-166.87,166.87Zm0-331.5c-90.78,0-164.63,73.85-164.63,164.63s73.85,164.63,164.63,164.63,164.63-73.85,164.63-164.63S471.65,2.24,380.87,2.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.87,154.55c-.62,0-1.12-.5-1.12-1.12V1.12c0-.62.5-1.12,1.12-1.12s1.12.5,1.12,1.12v152.31c0,.62-.5,1.12-1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m546.62,167.99h-152.31c-.62,0-1.12-.5-1.12-1.12s.5-1.12,1.12-1.12h152.31c.62,0,1.12.5,1.12,1.12s-.5,1.12-1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m367.43,167.99h-152.24c-.62,0-1.12-.5-1.12-1.12s.5-1.12,1.12-1.12h152.24c.62,0,1.12.5,1.12,1.12s-.5,1.12-1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.87,333.74c-.62,0-1.12-.5-1.12-1.12v-152.31c0-.62.5-1.12,1.12-1.12s1.12.5,1.12,1.12v152.31c0,.62-.5,1.12-1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m390.74,158.89c-.62,0-1.12-.5-1.12-1.12,0-.3.12-.58.33-.79l107.23-107.23c.44-.44,1.15-.44,1.58,0s.44,1.15,0,1.58h0l-107.23,107.23c-.21.21-.49.33-.79.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m371,158.89c-.3,0-.58-.12-.79-.33l-107.23-107.23c-.44-.44-.44-1.15,0-1.58s1.15-.44,1.58,0l107.23,107.23c.44.44.44,1.15,0,1.58-.21.21-.49.33-.79.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m497.97,284.32c-.3,0-.58-.12-.79-.33l-107.23-107.23c-.44-.44-.44-1.15,0-1.58s1.15-.44,1.58,0h0l107.23,107.23c.44.44.44,1.15,0,1.58-.21.21-.49.33-.79.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m263.77,284.32c-.62,0-1.12-.5-1.12-1.12,0-.3.12-.58.33-.79l107.23-107.23c.44-.44,1.15-.44,1.58,0s.44,1.15,0,1.58l-107.23,107.23c-.21.21-.49.33-.79.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.87,281.67c-63.4,0-114.79-51.4-114.79-114.79s51.4-114.79,114.79-114.79,114.79,51.4,114.79,114.79c-.07,63.37-51.42,114.72-114.79,114.79Zm0-227.35c-62.16,0-112.55,50.39-112.55,112.55s50.39,112.55,112.55,112.55,112.55-50.39,112.55-112.55c-.07-62.13-50.42-112.48-112.55-112.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 380.87,
    cy: 166.87,
    r: 13.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "328.84 393.88 317.03 394.22 374.66 161.61 385.38 164.88 328.84 393.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "432.9 393.88 444.71 394.22 387.08 161.61 376.37 164.88 432.9 393.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 361.83,
    y: 34.72,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 364.07,
    y: 39.2,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.99,
    y: 39.2,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.31,76.72c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m397.41,39.76h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 461.51,
    y: 79.52,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 463.75,
    y: 84,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 481.67,
    y: 84,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m479.99,121.51c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m469.61,66.64c-.64,0-1.22.36-1.5.93l-6.72,13.44c-.42.83-.08,1.84.75,2.25.23.12.49.18.75.18h34.19c.93,0,1.68-.75,1.68-1.68,0-.26-.06-.52-.18-.75l-6.72-13.44c-.28-.57-.87-.93-1.5-.93h-20.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 500.7,
    y: 180.31,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 502.94,
    y: 184.79,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 520.86,
    y: 184.79,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m519.18,222.31c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m536.28,185.35h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 459.27,
    y: 274.39,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 461.51,
    y: 278.87,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 479.43,
    y: 278.87,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m477.75,316.38c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m494.84,279.43h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 263.28,
    y: 79.52,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 283.44,
    y: 84,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265.52,
    y: 84,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m281.76,121.51c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m298.85,84.56h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 224.08,
    y: 180.31,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 244.24,
    y: 184.79,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 226.32,
    y: 184.79,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m242.56,222.31c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m259.65,185.35h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.52,
    y: 274.39,
    width: 36.96,
    height: 20.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 285.68,
    y: 278.87,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 267.76,
    y: 278.87,
    width: 14.56,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m284,316.38c-11.75-.01-21.27-9.53-21.28-21.28v-.56c0-2.78,2.26-5.04,5.04-5.04h32.48c2.78,0,5.04,2.26,5.04,5.04v.56c-.01,11.75-9.53,21.27-21.28,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m301.09,279.43h-34.19c-1.55,0-2.8-1.25-2.8-2.8,0-.43.1-.86.3-1.25l6.72-13.44c.47-.95,1.44-1.55,2.5-1.55h20.75c1.06,0,2.03.6,2.5,1.55l6.72,13.44c.69,1.38.13,3.06-1.25,3.76-.39.19-.82.3-1.25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m631.97,360.62c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-10.64v-4.48h10.64c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-90.72c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-10.64c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-10.64c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-9.52c-1.24,0-2.24,1-2.24,2.24s1,2.24,2.24,2.24h9.06c-.07.18-.1.37-.1.56v15.68c0,.93.75,1.68,1.68,1.68s1.68-.75,1.68-1.68v-15.68c0-.19-.04-.38-.1-.56h64.04c-.07.18-.1.37-.1.56v15.68c0,.93.75,1.68,1.68,1.68s1.68-.75,1.68-1.68v-15.68c0-.19-.04-.38-.1-.56h9.06c1.24,0,2.24-1,2.24-2.24s-1-2.24-2.24-2.24h-9.52v-4.48h10.64c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-10.64v-4.48h10.64Zm-77.84-6.72h64.96v4.48h-64.96v-4.48Zm64.96,17.92h-64.96v-4.48h64.96v4.48Zm0-6.72h-64.96v-4.48h64.96v4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m251.19,360.62c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-10.64v-4.48h10.64c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-90.72c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-10.64c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-10.64c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12h10.64v4.48h-9.52c-1.24,0-2.24,1-2.24,2.24s1,2.24,2.24,2.24h9.06c-.07.18-.1.37-.1.56v15.68c0,.93.75,1.68,1.68,1.68s1.68-.75,1.68-1.68v-15.68c0-.19-.04-.38-.1-.56h64.04c-.07.18-.1.37-.1.56v15.68c0,.93.75,1.68,1.68,1.68s1.68-.75,1.68-1.68v-15.68c0-.19-.04-.38-.1-.56h9.06c1.24,0,2.24-1,2.24-2.24s-1-2.24-2.24-2.24h-9.52v-4.48h10.64c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-10.64v-4.48h10.64Zm-77.84-6.72h64.96v4.48h-64.96v-4.48Zm64.96,17.92h-64.96v-4.48h64.96v4.48Zm0-6.72h-64.96v-4.48h64.96v4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m603.97,354.46h-3.36c-.93,0-1.68-.75-1.68-1.68v-3.36c0-.93.75-1.68,1.68-1.68h3.36c.93,0,1.68.75,1.68,1.68v3.36c0,.93-.75,1.68-1.68,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m602.36,350.76c-.06,0-.13,0-.19-.02-.61-.1-1.02-.68-.91-1.29,0,0,0,0,0,0l11.08-64.45c.11-.61.69-1.02,1.3-.91.61.11,1.01.68.91,1.29l-11.08,64.45c-.09.54-.56.93-1.1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m602.35,350.76c-.54,0-1.01-.39-1.1-.93l-11.08-64.45c-.1-.61.3-1.19.91-1.29s1.19.3,1.29.91h0l11.08,64.45c.1.61-.3,1.19-.91,1.29,0,0,0,0,0,0-.06.01-.13.02-.19.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m626.2,273.97c1.08-7.65-3-14.55-9.12-15.41s-11.95,4.64-13.03,12.28c-.91,6.45,1.86,12.35,6.42,14.57l-.26,1.84,5.54.78.26-1.84c4.99-.87,9.29-5.77,10.2-12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m600.48,270.49c-1.33-7.61-7.33-12.92-13.42-11.86s-9.95,8.09-8.62,15.7c1.12,6.42,5.57,11.18,10.59,11.89l.32,1.83,5.51-.96-.32-1.83c4.49-2.36,7.06-8.35,5.95-14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m602.29,349.42c-.62,0-1.12-.5-1.12-1.12v-66.25c0-.62.5-1.12,1.12-1.12s1.12.5,1.12,1.12v66.25c0,.62-.5,1.12-1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m612.79,269.32c0-7.72-5.01-13.99-11.19-13.99s-11.19,6.26-11.19,13.99c0,6.51,3.57,11.97,8.39,13.53v1.86h5.59v-1.86c4.82-1.55,8.39-7.01,8.39-13.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m835.17,395.94H40.8c-.74,0-1.34-.59-1.34-1.33,0-.74.59-1.34,1.33-1.34h794.38c.74,0,1.34.59,1.34,1.33s-.59,1.34-1.33,1.34h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "659.33 393.56 656.78 393.55 655.57 383.73 659.33 383.73 659.33 393.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m654.6,392.83h5.28v3.09h-8.01v-.36c0-1.51,1.22-2.73,2.73-2.73h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "677.81 390.67 675.5 391.73 670.31 383.3 673.73 381.73 677.81 390.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m673.21,391.97l4.8-2.19h0l1.29,2.81h0l-7.28,3.33h0l-.15-.33c-.63-1.37-.02-2.99,1.35-3.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m659.17,390.96h-2.43c-.49,0-.9-.38-.93-.87l-1.33-35.44c-.04-.51.35-.96.86-1,.05,0,.11,0,.16,0l14.07,1.49c.47.05.83.44.84.91l.29,15.63c0,.08.02.17.05.25l5.77,14.97c.19.48-.05,1.02-.54,1.21,0,0,0,0-.01,0l-2.47.91c-.44.16-.94-.03-1.15-.45l-7.09-13.79c-.04-.07-.07-.15-.08-.24l-1.21-5.84c-.08-.39-.47-.65-.86-.56-.31.06-.54.32-.57.63l-2.44,21.34c-.05.47-.45.83-.93.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 660.38,
    cy: 321.85,
    r: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m663.9,357.89c-3.29-.04-6.51-.96-9.33-2.67h0c-.3-.18-.47-.51-.44-.86l1.24-17.74c.16-2.43,1.46-4.64,3.51-5.95,1.95-1.29,4.4-1.58,6.61-.79.48.17.93.4,1.34.7,2.69,1.92,4.1,5.18,3.64,8.46-.91,6.9.12,16.21.24,17.25v.07s-.06.03-.06.03c-2.11.98-4.42,1.49-6.75,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m670.39,360.43c.92-.69,1.11-2,.41-2.93-.07-.1-.16-.19-.25-.27l2.99-6.79-3.8.64-2.26,6.35c-.73.9-.6,2.22.3,2.96.75.61,1.83.63,2.6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m670.68,356.23c-.26,0-.51-.11-.69-.3l-1.12-1.22c-.22-.24-.3-.58-.21-.9l2.56-8.65-3.89-8.17c-.17-.36-.21-.77-.12-1.15.23-.93,1.16-1.49,2.09-1.27.47.12.88.43,1.11.86l5.26,8.53c.42.67.47,1.51.14,2.23l-4.28,9.49c-.13.29-.39.49-.7.54-.05,0-.1.01-.15.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m664.58,326.35c-.53.09-.96-.65-1.03-1.16,0-.51.05-1.02.14-1.53.06-.55-.25-1.08-.76-1.29-.56-.16-1.08.29-1.65.24-.8-.08-1.2-1.01-1.3-1.77s-.17-1.65-.87-2.08c-.69-.43-1.54-.12-2.34-.1-1.39-.02-2.61-.93-3.02-2.26.33.1.69-.05.87-.35.14-.32.04-.69-.23-.91l1.52.74c-.15-.42.06-.89.49-1.05.02,0,.03-.01.05-.02.46-.12.95-.13,1.41-.01,2.38.37,5.13.19,6.71,2,1.19,1.47,1.85,3.3,1.87,5.19-.38,1.55-1.01,3.02-1.87,4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m637.52,335.05c1-.57,2.28-.22,2.85.78.06.11.11.22.15.33l7.42-.05-2.1,3.24-6.73-.45c-1.12.32-2.28-.33-2.59-1.45-.26-.93.15-1.93.99-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m641.39,338.57c-.05-.26,0-.52.16-.74l.96-1.34c.19-.27.51-.41.84-.39l8.69-.36,7.51-4.37c.32-.24.71-.36,1.1-.35.95.03,1.7.83,1.67,1.78-.02.49-.24.95-.61,1.26l-7.28,6.89c-.57.54-1.38.77-2.15.59l-10.16-2.26c-.31-.07-.56-.29-.67-.58-.02-.05-.03-.09-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m513.71,389.37c.4-1.12-.19-2.35-1.31-2.75-.12-.04-.24-.07-.37-.09l-1.29-7.54-2.9,2.72,1.67,6.74c-.12,1.19.75,2.25,1.94,2.36.99.1,1.93-.5,2.26-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m511.79,385.77l-2.85.75c-.28.07-.57-.09-.65-.37l-5.12-18.13-1.55-4.62c-.49-1.46.3-3.04,1.76-3.52.39-.13.81-.17,1.22-.12h0c1.1.13,2.02.91,2.34,1.97l4.09,13.82,1.15,9.65c.03.22-.09.43-.28.54-.04.02-.07.03-.11.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 501.38,
    cy: 351.43,
    r: 5.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "485.91 423.31 483.4 422.56 485.08 412.51 488.8 413.62 485.91 423.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m485.83,425.94l-8.11-2.41.03-.1c.52-1.74,2.35-2.73,4.09-2.22t0,0h0l4.95,1.47-.97,3.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "513.45 423.18 510.83 423.18 509.58 413.07 512.17 413.07 513.45 423.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m514.12,425.72h-8.46v-.11c0-1.82,1.47-3.29,3.29-3.29h5.17s0,3.4,0,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m486.88,420.34h-2.63c-.53,0-.96-.43-.96-.96,0-.06,0-.12.02-.17-1.68-.75,7.36-44.11,9.5-43.27l.07-.1,10.76.88c4.82,9.64,7.87,25.6,10.72,42.26.13.52-.18,1.04-.7,1.17-.06.02-.13.03-.19.03l-2.96.14c-.41.02-.79-.22-.94-.6l-11.34-28.34c-.05-.13-.17-.21-.31-.2-.13,0-.25.09-.3.22l-9.84,28.31c-.13.39-.5.65-.91.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m503.85,377.56h-.08s-11.45-.87-11.45-.87l2.01-12.78c.45-2.93,2.78-5.21,5.72-5.61h0c.09-.01.18-.02.27-.04,2.29-.3,4.56.61,6.01,2.4,1.48,1.8,1.92,4.25,1.15,6.45l-3.61,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m511.58,357.44c-3.61,1.65-8.52,1.36-14.12,0,.78-2.12,1.38-4.18.69-5.68-.56-1.15-.61-2.48-.15-3.67,1.1-2.63,3.67-4.34,6.52-4.34h0c3.9,0,7.06,3.16,7.06,7.06h0v6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m499.99,344.23h3.89v5.52h-9.41c0-3.05,2.47-5.52,5.52-5.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m492.07,390.56c.88-.8.93-2.16.13-3.04-.09-.09-.18-.18-.28-.26l2.39-7.26-3.83,1.04-1.68,6.74c-.66,1-.39,2.34.61,3,.83.55,1.94.46,2.67-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m492.05,386.47l-2.87-.67c-.28-.07-.46-.35-.4-.63l3.98-18.41.8-4.81c.25-1.52,1.69-2.54,3.21-2.29.41.07.79.23,1.13.46h0c.91.63,1.36,1.75,1.14,2.84l-2.86,14.12-3.5,9.07c-.08.21-.28.34-.5.34-.04,0-.08,0-.12-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m580.6,346.46c-.11.03-.22.07-.32.11l-8.61-5.55.12-2.49-3.73-.67-.64,4.38c-.11.73.28,1.44.95,1.74l10.6,4.84c.14,1.19,1.22,2.04,2.41,1.89,1.19-.14,2.04-1.22,1.89-2.41-.14-1.19-1.22-2.04-2.41-1.89-.09.01-.18.03-.26.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m571.32,340.86l-4.62-.85c-.5-.09-.84-.58-.75-1.08,0-.04.02-.09.03-.13l1.52-4.43c.26-1.4,1.61-2.32,3.01-2.06,1.4.26,2.32,1.61,2.06,3.01h0l-.16,4.66c-.02.51-.45.91-.96.9-.05,0-.09,0-.14-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m587.37,328.85c-.03.11-.04.22-.05.34l-8.87,5.12-2.16-1.24-2.3,3.01,3.6,2.57c.6.43,1.41.41,1.98-.05l9.15-7.22c1.12.42,2.37-.16,2.79-1.28.42-1.12-.16-2.37-1.28-2.79-1.12-.42-2.37.16-2.79,1.28-.03.08-.06.17-.08.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m578.15,334.55l-2.87,3.72c-.31.41-.9.48-1.3.17-.04-.03-.07-.06-.1-.09l-3.25-3.37c-1.13-.87-1.33-2.5-.46-3.62.87-1.13,2.5-1.33,3.62-.46h0l4.07,2.28c.45.25.61.82.36,1.27-.02.04-.05.08-.08.11h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 566.41,
    cy: 320.6,
    r: 5.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "571.2 393.25 573.73 393.25 574.93 383.48 571.2 383.48 571.2 393.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m570.55,392.42h4.99s0,0,0,0c1.76,0,3.18,1.42,3.18,3.18h0v.1h-8.17s0-3.28,0-3.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "562.52 393.25 565.05 393.25 566.26 383.48 562.52 383.48 562.52 393.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m561.88,392.42h4.99s0,0,0,0c1.76,0,3.18,1.42,3.18,3.18h0v.1h-8.17s0-3.28,0-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m570.44,389.54l-2.58-19.99c0-.06-.05-.1-.1-.1-.05,0-.1.04-.1.09,0,0,0,0,0,0l-.74,19.7c-.02.5-.43.9-.93.89h-3.07c-.51,0-.92-.4-.93-.91l-.8-32.82,13.73.14.34,32.92c0,.26-.12.51-.33.69-.2.17-.46.25-.71.21h-2.97c-.43-.05-.77-.41-.8-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m560.98,357.32c-.31-.12-.54-.4-.59-.73l-.14-18.03c-.61-4.02-1.32-7.95,2.19-9.98l.31-.93c.07-.21.26-.35.48-.35l6.66-.19c.21,0,.41.12.49.31l.5,1.16.18.1c3.42,1.95,5.34,5.76,4.87,9.67l-.38,3.22-.27,15.02c0,.34-.19.64-.49.8-1.88.98-3.98,1.47-6.11,1.42-2.63-.05-5.24-.55-7.7-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m566.24,325.87c-2.99.06-5.46-2.31-5.53-5.29-.06-2.99,2.31-5.46,5.29-5.53.42,0,.84.03,1.25.12,1.1-.72,2.4-1.08,3.71-1.02,1.33.08,2.51.89,3.07,2.1.51,1.26-.03,2.69-1.24,3.3-.81.23-1.66.25-2.48.04-.82-.21-1.68-.13-2.45.22-.72.43-1.04,1.57-.4,2.1.7.6.95,1.57.64,2.44-.31.8-1.02,1.38-1.87,1.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "272.04 423.09 274.51 423.09 275.68 413.57 272.04 413.57 272.04 423.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m270.95,425.94v-4.12s5.32,0,5.32,0c1.96,0,3.55,1.59,3.56,3.56v.56h-8.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "258.74 423.09 261.21 423.09 262.38 413.57 258.74 413.57 258.74 423.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.65,425.94v-4.12s5.32,0,5.32,0c1.96,0,3.55,1.59,3.56,3.56v.56h-8.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 265.97,
    cy: 350.11,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m284.1,384.69c-.14-1.11-1.15-1.9-2.26-1.76-.12.01-.24.04-.35.08l-2.96-3.55-2.6,1.27,4.26,4.96c.4,1.05,1.58,1.57,2.63,1.17.88-.34,1.41-1.23,1.29-2.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m258.59,388.28c.48-1.01.04-2.22-.97-2.69-.11-.05-.22-.09-.33-.12l-.59-4.59-2.88-.32.93,6.47c-.22,1.1.49,2.17,1.6,2.4.92.19,1.85-.29,2.25-1.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m261.54,360.13h0c-.89-1.14-2.52-1.34-3.66-.46-.36.28-.65.66-.82,1.09l-4.35,10.85c-.44,1.11-.59,2.31-.41,3.5l1.42,9.53c.07.47.51.8.98.73.04,0,.09-.02.13-.03l1.87-.57c.4-.12.65-.51.6-.93h0c-.66-5.61.21-11.3,2.52-16.46l2.05-4.58c.39-.88.27-1.91-.32-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.68,355.41c-3.12.07-5.71-2.41-5.78-5.53-.07-3.12,2.41-5.71,5.53-5.78.44,0,.88.03,1.3.12,1.15-.76,2.51-1.13,3.88-1.06,1.39.09,2.62.93,3.21,2.19.53,1.31-.03,2.81-1.3,3.45-.84.24-1.74.26-2.59.04-.85-.22-1.76-.14-2.56.23-.75.45-1.09,1.64-.42,2.2.73.63,1,1.65.67,2.55-.32.84-1.06,1.45-1.95,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.1,384.48l-.94,35.69c-.01.48.36.87.84.89.02,0,.04,0,.07,0l3.1-.16c.41-.02.74-.32.81-.73l3.69-23.18c.04-.24.26-.4.49-.36.17.03.32.16.35.33l4.99,22.32c.1.47.57.76,1.03.65.03,0,.07-.02.1-.03l3.07-.19c.37-.13.6-.49.57-.87l-2.68-34.71-15.49.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m256.59,367.53c-.55-5.35,3.34-10.12,8.69-10.67.06,0,.13-.01.19-.02,2.34-.17,5.96-.23,7.16,2.84,3.6,9.22-2.7,9-.53,16.99,2.17,7.99,4.09,8.45,1.11,9.02-2.98.58-16.38,3.98-15.83-1.64.34-3.46-.27-11.12-.79-16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m271.99,358.74h0c-1.34-.52-2.85.15-3.37,1.49-.17.43-.22.9-.14,1.35l1.69,10.58c.29,1.81,1.05,3.51,2.22,4.92l5.5,6.7c.3.37.85.42,1.22.12.03-.03.06-.06.09-.09l1.31-1.45c.28-.31.3-.77.04-1.1l-.38-.5c-3.2-4.15-5.21-9.09-5.84-14.29l-.67-5.61c-.11-.96-.75-1.77-1.65-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m284.35,387.15c1.03-.51,1.45-1.76.94-2.79-.05-.11-.12-.21-.19-.31l1.55-15.2h-3.36l-1.24,14.84c-.88.75-.99,2.07-.24,2.95.63.74,1.67.95,2.54.51h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 287.44,
    cy: 355.7,
    r: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m288.33,377.7c-.39,0-.73-.26-.84-.64-.8-2.39-1.78-4.72-2.95-6.95-1.39-2.86-.2-6.31,2.66-7.7.2-.1.4-.18.61-.25h0c3-1.06,6.29.51,7.35,3.51.02.05.04.1.05.16.89,3.08,1.26,6.3,1.08,9.5-.02.39-.3.72-.68.81l-7.1,1.55c-.06.01-.12.02-.19.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "295.2 422.84 297.57 422.84 298.7 413.69 295.2 413.69 295.2 422.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m302.71,425.61h-8.58v-4s5.14,0,5.14,0c1.9,0,3.44,1.54,3.44,3.44h0s0,.56,0,.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "271.47 419.77 273.55 420.91 278.95 413.43 275.88 411.75 271.47 419.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m276.72,425.81l-7.52-4.13,1.93-3.51,4.5,2.48c1.67.92,2.27,3.01,1.36,4.67l-.27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m295.09,417.76c-.44,0-.81-.33-.86-.76l-2.97-22.87c-.03-.27-.28-.45-.54-.42-.15.02-.29.11-.36.25l-12.37,22.44c-.21.38-.67.55-1.07.39l-2.7-1.03c-.45-.17-.68-.67-.5-1.12,0,0,0-.01,0-.02l8.57-21.05c.02-.05.04-.11.04-.17,1.16-8.98,4.11-13.55,4.99-14.74.13-.18.17-.41.1-.61l-.12-.36c-.1-.29-.03-.61.17-.85,3.16-3.6,8.67-1.64,8.73-1.62h.03s.02.03.02.03c6.18,8.47,3.89,35.99,3.37,41.42-.04.42-.38.75-.8.78l-3.65.28s-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m305.92,361.22c-.02.1-.04.21-.05.32l-8.31,4.8-2.02-1.16-2.15,2.82,3.38,2.41c.56.4,1.32.38,1.86-.05l8.57-6.76c1.05.39,2.22-.15,2.61-1.2.39-1.05-.15-2.22-1.2-2.61-1.05-.39-2.22.15-2.61,1.2-.03.08-.05.16-.07.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m297.28,366.57l-2.69,3.48c-.29.38-.84.45-1.22.16-.03-.03-.07-.05-.1-.09l-3.04-3.16c-1.05-.82-1.24-2.34-.42-3.4.82-1.05,2.33-1.24,3.38-.43l3.82,2.13c.42.23.57.77.33,1.19-.02.04-.04.07-.07.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m286.86,372.62l-4.33-.78c-.47-.09-.79-.54-.7-1.01,0-.04.02-.08.03-.12l1.4-4.16c.24-1.31,1.51-2.18,2.82-1.94,1.31.24,2.18,1.5,1.94,2.81l-.14,4.37c-.02.48-.42.86-.9.84-.04,0-.09,0-.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m288.19,354.61c1.22.84,2.83,1.7,4.07.81.8-.61,1.11-1.68.75-2.62-.6-1.71-2.24-2.46-3.81-3.04-1.99-.9-4.21-1.18-6.37-.81-2.11.54-3.97,2.58-3.59,4.72.31,1.72,1.93,3.15,1.7,4.89-.23,1.74-2.19,2.66-3.93,2.97-1.73.31-3.67.41-4.91,1.66-1.59,1.59-1.19,4.42.3,6.1,1.63,1.56,3.7,2.59,5.93,2.95,2.89.68,6.03,1.04,8.77-.09,2.75-1.14,4.89-4.19,4.09-7.06-.42-1.19-1.06-2.28-1.89-3.23-.83-.95-1.46-2.06-1.83-3.26-.27-1.03-.05-2.13.61-2.96.25-.27.3-.68.12-1v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m285.88,307.91h-1.19v-7.12h-2.58v-.95c1.36,0,2.59-.35,2.86-1.86h.91v9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m239.55,207.42c-.11-2.02,1.09-3.52,3.19-3.52,1.72,0,3.11,1.01,3.11,2.86,0,1.75-1.18,2.62-2.41,3.4-1.23.74-2.56,1.4-2.79,2.62h5.1v1.05h-6.49c.18-2.34,1.39-3.22,2.79-4.06,1.68-1.05,2.54-1.64,2.54-3.03,0-1.08-.87-1.79-1.92-1.79-1.39,0-1.98,1.27-1.93,2.47h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m281.03,107.28c.1.01.18.01.27.01h.25c1.01,0,1.89-.56,1.89-1.62s-.76-1.6-1.77-1.6c-1.29,0-1.88.99-1.88,2.16h-1.19c.07-1.89,1.08-3.21,3.07-3.21,1.72,0,3.03.83,3.03,2.66,0,.88-.6,1.62-1.37,1.98v.03c1.22.27,1.79,1.22,1.79,2.41,0,1.98-1.56,3.03-3.42,3.03-2.02,0-3.35-1.18-3.31-3.24h1.19c.04,1.29.76,2.19,2.12,2.19,1.16,0,2.16-.73,2.16-1.92s-.94-1.91-2.12-1.91c-.25,0-.49.01-.71.04v-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m382.38,64.87h1.34v1.05h-1.34v2.33h-1.12v-2.33h-4.36v-1.15l4.52-6.46h.95v6.56Zm-1.12,0v-4.86h-.03l-3.31,4.86h3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m482.76,104.16h-4.01l-.53,2.86.03.03c.43-.49,1.18-.71,1.85-.71,1.76,0,3.21,1.12,3.21,3.4,0,1.68-1.16,3.31-3.47,3.31-1.72,0-3.12-1.05-3.17-2.84h1.19c.07,1.02.9,1.79,2.09,1.79s2.1-.78,2.1-2.35c0-1.3-.9-2.26-2.24-2.26-.77,0-1.39.38-1.85.94l-1.02-.06.92-5.15h4.9v1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m521.08,206.36c-.11-.9-.71-1.48-1.67-1.48-2.02,0-2.37,2.24-2.41,3.77l.03.03c.56-.91,1.4-1.3,2.48-1.3,1.9,0,3.04,1.39,3.04,3.22,0,1.46-.81,3.33-3.32,3.33-2.96,0-3.42-2.7-3.42-4.78,0-2.73.83-5.32,3.66-5.32,1.64,0,2.65.91,2.8,2.54h-1.19Zm-3.85,4.3c0,1.23.76,2.21,2.06,2.21s2-1.02,2-2.2-.64-2.26-2-2.26-2.06.99-2.06,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m480.96,299.09c-2,1.98-3.63,5.65-3.81,8.74h-1.33c.22-3.36,1.84-6.44,3.92-8.64h-5.21v-1.12h6.43v1.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWheel);
export default __webpack_public_path__ + "static/media/bigWheel.740084450b9f27a9f65c55824457b93c.svg";
export { ForwardRef as ReactComponent };